import BaggageItemIcon from './BaggageItemIcon/BaggageItemIcon';
import PayByMilesSwitch from './SearchForm/components/PayByMilesSwitch/PayByMilesSwitch';
import InitialHint from './Checkin/InitialHint/InitialHint';
import RetrieveHint from './Checkin/RetrieveHint/RetrieveHint';
import SelectedPassenger from './Checkin/SelectedPassenger/SelectedPassenger';
import Traveller from './Account/Traveller/Traveller';
import DesktopFlightModalContent from './DesktopFlightModalContent/DesktopFlightModalContent';
import SwitchBlock from './FareLock/SwitchBlock/SwitchBlock';
import FlightCardAirline from './FlightCardAirline/FlightCardAirline';
import InfoLinksLabel from './InfoLinksLabel/InfoLinksLabel';
import RequestForm from './RequestForm/RequestForm';
import CheckoutBaggage from './CheckoutBaggage/CheckoutBaggage';
import Baggage from './Baggage/Baggage';
import PaymentFormCards from './PaymentFormCards/PaymentFormCards';
import ResultsEmptyError from './Results/ResultsEmptyError/ResultsEmptyError';
import Account from './Checkout/Account/Account';
import SeatMapSeat from './SeatMapSeat/SeatMapSeat';
import SpecialEquipmentCard from './Baggage/SpecialEquipmentCard/SpecialEquipmentCard';
import OrderInsuranceBlockSlotUpsale from '@websky/core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
import Order from './Engine/Checkout/Order';
import CheckoutPaymentHeader from './Checkout/PaymentHeader/PaymentHeader';
import PassengerToolbarAdditional from './Checkout/PassengerToolbar/PassengerToolbarAdditional';
import SeatMap from './SeatMap/SeatMap';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
export const auroraRenderers = {
    renderOrderRoute: Order,
    renderBaggageItemIcon: BaggageItemIcon,
    SearchFormPayByMilesSwitch: PayByMilesSwitch,
    renderCheckinInitialHint: InitialHint,
    renderCheckinRetrieveHint: RetrieveHint,
    renderCheckinSelectedPassenger: SelectedPassenger,
    renderTravelCompanionsTraveller: Traveller,
    renderDesktopFlightModalContent: DesktopFlightModalContent,
    renderFareLockSwitchBlock: SwitchBlock,
    renderFlightCardAirline: FlightCardAirline,
    renderCheckoutInfoLinksLabel: InfoLinksLabel,
    RequestForm,
    CheckoutBaggage,
    Baggage: {
        Baggage,
        SpecialEqupment: {
            BaggageCard: SpecialEquipmentCard
        }
    },
    PaymentFormCards,
    specialEquipmentItemsSort: (a, b) => a[0].value.amount - b[0].value.amount,
    ResultsEmptyError,
    CheckoutAccount: Account,
    SeatMapSeat,
    CheckoutInsurance: OrderInsuranceBlockSlotUpsale,
    CheckoutPaymentHeader: CheckoutPaymentHeader,
    renderPassengersToolbarAdditional: PassengerToolbarAdditional,
    SeatMapService: SeatMap,
    CheckinServices: CheckinServicesV2
};
